import React from "react";
import Layout from "../components/layout";

import WebsiteImage from "./images/background.svg";
import BpmImage from "./images/pexels-florian-g-7220729.jpg";
import GerrymanderingImage from "./images/map-g14aa14049_1920.jpg";
// import TunerImage from "./images/guitar-g6aee8792c_1920.jpg";
import { ConditionalWrapper } from "../components/conditional-wrapper";
import { SkewedTextBox } from "../components/SkewedTextBox";
import { ChipContainer } from "../components/chip-container";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

interface PortfolioItemProps {
  title: string;
  image: string;
  color: string;
  stack: string[];
  link?: string;
  children?: React.ReactNode;
}

const PortfolioItem = (props: PortfolioItemProps) => {
  return (
    <div
      className="flex-grow-0 flex-shrink-0 h-[240px] min-w-[480px] max-w-[600px] border-0 bg-cover bg-center"
      style={{
        backgroundColor: props.color,
        backgroundImage: `url(${props.image})`,
      }}
    >
      <ConditionalWrapper
        condition={!!props.link}
        wrapper={(children) => (
          <a href={props.link} target="_blank" rel="noopener noreferrer"
          className={clsx("block size-full",
            "focus-visible:outline-none",
            "focus-visible:ring focus-visible:ring-foreground focus-visible:ring-offset-4 focus-visible:ring-offset-page ring-contrast"
          )}
          >
            {children}
          </a>
        )}
      >
        <div className="size-full flex flex-col justify-center items-center">
          <SkewedTextBox variant="h4">{props.title}</SkewedTextBox>
          <ChipContainer className="pt-2">
            {props.stack.map((entry, i) => (
              <SkewedTextBox key={i} variant="caption" color="secondary">
                {entry}
              </SkewedTextBox>
            ))}
          </ChipContainer>
        </div>
      </ConditionalWrapper>
    </div>
  );
};

const PortfolioPage = () => {
  const { t } = useTranslation();
  return (
    <Layout title="Portfolio" fullWidth>
      <div className="flex flex-wrap justify-center gap-4">
        <PortfolioItem
          title={t("portfolio_title")}
          image={WebsiteImage}
          color="transparent"
          stack={["TypeScript", "React", "Tailwind", "i18next"]}
        >
          TypeScript, React, Tailwind
        </PortfolioItem>
        <PortfolioItem
          title="BPM Tapper"
          image={BpmImage}
          color="#B4B3AD"
          link="https://bpm.christianfoerg.de"
          stack={["TypeScript", "Angular", "SCSS"]}
        >
          TypeScript, Angular, SCSS
        </PortfolioItem>
        <PortfolioItem
          title="Gerrymandering"
          image={GerrymanderingImage}
          color="#CB9701"
          link="https://districts.christianfoerg.de"
          stack={["TypeScript", "MVC", "OpenLayers"]}
        >
          “Vanilla” TypeScript, MVC, OpenLayers
        </PortfolioItem>
        {/* <GalleryItem
            title="Guitar Tuner"
            image={TunerImage}
            color="transparent"
            link="https://tuner.christianfoerg.de"
          /> */}
      </div>
    </Layout>
  );
};

export default PortfolioPage;
